class oGiftCard extends HTMLDivElement {
    constructor() {
        super();
        this.giftCard = document.querySelector('[is="o-gift-card"]');
        this.giftCardForm = document.getElementById('giftCardForm');
        this.giftCardFormSubmit = document.getElementById('giftCard-form-submit');
        this.giftCardFormMessage = document.getElementById('giftCard-form-message');
        this.giftCardComments = document.getElementById('giftCard-form-comment');
        this.giftCardCommentsCharacters = document.getElementById('giftCard-comments-characters');
        this.gifteeEmail = document.getElementById('giftCard-form-email');
        this.gifteeEmailConfirmation = document.getElementById('giftCard-form-email-confirmation');
        this.gifteeEmailConfirmationErrorValue = document.getElementById('giftCard-form-email-confirmation').dataset.customError;
        this.gifteeEmailConfirmationMsg = this.gifteeEmailConfirmation.closest('.input-wrapper').querySelector('.invalid-feedback');
        this.giftCardHeader = this.giftCard.querySelector('.header-text');

        this.addToCartGiftCard = this.addToCartGiftCard.bind(this);
        this.updateCommentsLabel = this.updateCommentsLabel.bind(this);
        this.updateErrorMsg = this.updateErrorMsg.bind(this);
        this.anchorToForm = this.anchorToForm.bind(this);
    }

    connectedCallback() {
        this.giftCardForm.addEventListener('submit', this.addToCartGiftCard);
        this.giftCardComments.addEventListener('input', this.updateCommentsLabel);
        this.gifteeEmail.addEventListener('input', this.updateErrorMsg);
        this.gifteeEmailConfirmation.addEventListener('input', this.updateErrorMsg);
        this.giftCard.style.setProperty('--gift-card-text-color', this.giftCardHeader.dataset.textColor);
    }

    addToCartGiftCard(e) {
        e.preventDefault();

        this.updateErrorMsg();

        fetch(this.giftCardForm.action, {
            method: 'POST',
            body: new FormData(this.giftCardForm),
        })
            .then((response) => response.json()).then((data) => {
                if (data.error) {
                    this.giftCardForm.setFormMessage('error', data.message ? data.message : 'ERROR');
                } else {
                    document.dispatchEvent(new CustomEvent('oSidebarAjax:prepareAndSendEvent', { detail: { sidebarId: 'o-sidebar-miniCart' } }));

                    if (data.gtmData) {
                        if (data.gtmData.event === 'add_to_cart') {
                            data.gtmData.add_to_cart_type = 'Cart';
                        }
                        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: data.gtmData,
                            },
                        }));
                    }
                    document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
                        detail: {
                            productCount: data.quantityTotal,
                        },
                    }));
                }
            });
    }

    updateCommentsLabel() {
        const fieldParent = this.giftCardComments.closest('.form-field');

        if (this.giftCardComments.value) {
            fieldParent.classList.add('is-active');
        } else {
            fieldParent.classList.remove('is-active');
        }

        const characterCounter = fieldParent.querySelector('.comments-character-current');
        const numOfEnteredChars = this.giftCardComments.value.length;
        const maxCharacters = this.giftCardComments.maxLength;
        characterCounter.textContent = maxCharacters - numOfEnteredChars;
    }

    updateErrorMsg() {
        this.giftCardFormSubmit.disabled = false;
        this.giftCardFormMessage.textContent = '';

        if (this.gifteeEmailConfirmation.value
            && this.gifteeEmail.value !== this.gifteeEmailConfirmation.value) {
            this.gifteeEmailConfirmation.setAttribute('aria-invalid', false);
            this.gifteeEmailConfirmation.closest('.input-wrapper').classList.add('error');
            this.gifteeEmailConfirmation.closest('.input-wrapper').classList.remove('valid');
            this.gifteeEmailConfirmation.setCustomValidity(' ');
            this.gifteeEmailConfirmationMsg.innerHTML = this.gifteeEmailConfirmationErrorValue;
            this.giftCardFormSubmit.disabled = true;
        } else {
            this.gifteeEmailConfirmation.setCustomValidity('');
        }
    }

    anchorToForm(e) {
        e.preventDefault();

        document.querySelector(e.target.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
        });
    }
}

customElements.define('o-gift-card', oGiftCard, {
    extends: 'div',
});
